// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"431":"a81f3f12","602":"0fd83bdc"}[chunkId] + ".chunk.js";
};